import type { CSSProperties } from 'react';
import { TIER_COLORS } from './scoreColors';

export function scoreBadgeStyle(
  score: number | null,
  colors: Record<number, string> = TIER_COLORS,
): CSSProperties {
  return {
    display: 'inline-block',
    padding: '1px 8px',
    borderRadius: 4,
    background: score != null ? (colors[score] ?? 'var(--gray-600)') : 'var(--gray-800)',
    color: score != null ? '#fff' : 'var(--gray-500)',
    fontWeight: 600,
    fontSize: '0.82rem',
    minWidth: 24,
    textAlign: 'center',
  };
}
